var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('template',{slot:"content"},[_c('header',{staticClass:"content__title"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('list',{attrs:{"entries":_vm.entries}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }